// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'coa-list-no-data',
  templateUrl: './list-no-data.component.html',
  styleUrls: ['./list-no-data.component.scss'],
})
export class ListNoDataComponent {
  @Input() title: string = marker('No results for selected criteria.');
  @Input() subTitle: string = marker('Try changing the keywords or filters.');
}
